// extracted by mini-css-extract-plugin
export var closeButton = "_n7-1";
export var closeX = "_n7-3";
export var container = "_n7-0";
export var image = "_n7-2";